module.exports = __webpack_public_path__ + "img/download_on_the_app_store.a832e04c.svg";